import React, { Component } from "react";
import { connect } from "react-redux";
import Input from "@components/Input";
import { unitLabel, unitTransform } from "@services/helper.service";
import SafetyBarriersBuilding from "../../../../assets/images/Safety_Barriers_Building.png";
import WindZoneFrance from "../../../../assets/images/Wind_Zone_France.png";
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import { APP_TYPES, defaultUnits } from "@config";
import {
  setCladdingDeadLoad,
  setCladdingWindLoad,
  setCladdingBuildingDimensions,
} from "@reducers/selectors/loads/actions";
import "./styles.scss";
import { APP_TEXTS } from "@texts";
import { Tooltip } from "@components/Tippy";
import { APP_TOOLTIPS } from "@tooltips";
import Popup from "reactjs-popup";
import loadsTabService from "@services/requests/loads-tab.service";
import { LOAD } from "@reducers/units";

class DeadLoadAndWindLoad extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedTown: null, 
      zipCode: '',
      isValidZipCode: false,
      waitingResponse: false,
      towns: []
    };
  }

  handleBuildingDimensionChange = (field, value) => {
    const numericValue = field === 'isEdge' ? value : (value === "" ? 0 : Number(value));
    this.props.setCladdingBuildingDimensions({
      ...this.props.buildingDescription,
      [field]: numericValue,
    });
  };
  handleDeadLoadUpdate = (value) => {
    this.props.setCladdingDeadLoad(
      unitTransform(Number(value) || 0, false)
        .from(this.props.loadUnit)
        .to(defaultUnits.LOAD)
    );
  };
  handleWindZoneChange = (zone) => {
    this.props.setCladdingWindLoad({
      ...this.props.windLoadData,
      windZone: zone,
      vb: 0,
    });
  };
  handleWindSpeedChange = (speed) => {
    this.props.setCladdingWindLoad({
      ...this.props.windLoadData,
      vb: speed === "" ? 0 : Number(speed),
      windZone: 0,
    });
  };
  handleGroundCategoryChange = (category) => {
    this.props.setCladdingWindLoad({
      ...this.props.windLoadData,
      groundCategory: category,
    });
  };
  getZoneFromValue = (value) => {
    return value || "Select Zone";
  };
  
  queryZipCode(code) {
    this.setState({ waitingResponse: true });
    loadsTabService.getFrenchAreas(code).then((res) => {
      if (res && res.length && this.state.zipCode === res[0].PostalCode) { // check if the zipCode was changed in the meantime
        let selectedTown = this.state.selectedTown;
        selectedTown = selectedTown && res.find(town => town.Town === selectedTown.Town);
        if (!selectedTown)
          selectedTown = res[0];
        this.setState({ isValidZipCode: true, towns: res, selectedTown, waitingResponse: false });
      } else {
        this.setState({ waitingResponse: false, isValidZipCode: false, selectedTown: null, towns: [] });
      }
    }, () => this.setState({ waitingResponse: false, isValidZipCode: false }));
  }

  render() {
    const groundCategories = ["0", "II", "IIIa", "IIIb", "IV"];
    const isFrance = this.props.country === "7";
    const windZoneOptions = [1, 2, 3, 4];

    return (
      <div
        className="calculation flex wind-load list-type"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <section>
          <h4>{APP_TEXTS.DEAD_LOAD_TITLE.Content}</h4>
          <div className="mb-4">
            <label className="form-check-label" htmlFor="dead_load_input">
              G:
              <Input
                className="w-32 dead-load-input"
                postfix={unitLabel(this.props.loadUnit) + (this.props.loadUnit === LOAD.POUND_FORCE ? "/ft" : "/ml")}
                id="dead_load_input"
                value={unitTransform(this.props.deadLoad)
                  .from(defaultUnits.LOAD)
                  .to(this.props.loadUnit)}
                onUpdate={this.handleDeadLoadUpdate}
                type="number"
              />
            </label>
          </div>
          <h4>{APP_TEXTS.WIND_LOAD_TITLE.Content}</h4>
          <div className="mb-4">
            <div className="d-flex align-items-center mb-2">
              <span className="mr-2">
                {isFrance ? APP_TEXTS.WIND_ZONE_TITLE.Content : APP_TEXTS.WIND_VB_TITLE.Content}
              </span>
              {isFrance ? (
                  <React.Fragment>
                    <select
                      className="select__windzone form-control"
                      name={"WindZone"}
                      value={this.getZoneFromValue(this.props.windLoadData.windZone)}
                      onChange={e => this.handleWindZoneChange(e.target.value)}
                      disabled={this.state.selectedTown}
                    >
                      {this.props.windLoadData.windZone === 0 && (
                        <option value={0} key={0}>{this.getZoneFromValue(this.props.windLoadData.windZone)}</option>
                      )}
                      {windZoneOptions && windZoneOptions.map(n => (
                        <option value={n} key={n}>{n}</option>
                      ))}
                    </select>
                    <div className="mx-3">
                      <Tooltip content={APP_TOOLTIPS.TOOLTIP_WIND_FRANCE_MAP.Content}>
                        <Popup 
                          modal={true}
                          closeOnDocumentClick={false}
                          className="map_popup default_popup"
                          trigger={( 
                            <button className="btn p-0">
                              <span className="icon_seismic-btn align-middle"/>
                            </button>
                          )}
                          onOpen={() => {
                            if (this.state.selectedTown) {
                              if (this.state.selectedTown.PostalCode)
                                this.queryZipCode(this.state.selectedTown.PostalCode);
                              this.setState({ 
                                selectedTown: this.state.selectedTown, 
                                zipCode: this.state.selectedTown.PostalCode || '',
                                isValidZipCode: this.state.selectedTown.PostalCode ? true : false });
                            } else {
                              this.setState({ 
                                selectedTown: null, 
                                zipCode: '',
                                isValidZipCode: false });
                            }
                          }}
                          >
                          {close =>(
                            <React.Fragment>
                              <h4 className="default_popup-header">{APP_TEXTS.LOADS_MAP.Content}</h4>
                              <div className="default_popup-text">
                                <div className="left-side">
                                  <img 
                                    src={WindZoneFrance}
                                    alt="Wind zones map of France"
                                    style={{width: "75%"}}
                                    />
                                </div>
                                <section className="list-type ml-2 right-side">
                                  <div>
                                    <p>{APP_TEXTS.LOADS_WIND_FRANCE_DESC.Content}</p>
                                    <p><b>{APP_TEXTS.LOADS_WIND_ZONE_1.Content}<br/>
                                    {APP_TEXTS.LOADS_WIND_ZONE_2.Content}<br/>
                                    {APP_TEXTS.LOADS_WIND_ZONE_3.Content}<br/>
                                    {APP_TEXTS.LOADS_WIND_ZONE_4.Content}</b></p>
                                  </div>
                                  
                                  <div>
                                  <Input 
                                    className="mb-2 mt-2"
                                    id="zip-code"
                                    prefix={(<b>{APP_TEXTS.LOADS_ZIP_CODE.Content}</b>)}
                                    postfix={this.state.waitingResponse ? 
                                      (<div className="spinner-border text-dark ml-2"/>) : 
                                      (this.state.zipCode ? 
                                        (this.state.isValidZipCode ? 
                                          (<span className="icon_check ml-2"/>) : 
                                          (<span className="icon_uncheck ml-2"/>)) :
                                        (<span/>)
                                      )}
                                    value={this.state.zipCode}
                                    onUpdate = { value => { 
                                      if (value !== this.state.zipCode) {
                                        this.setState({ zipCode: value }); 
                                        if (value.toString().length === 5) {
                                          this.queryZipCode(value);
                                        } else {
                                          this.setState({ isValidZipCode: false });
                                        }
                                      }
                                    }}
                                  />
                                  {this.state.isValidZipCode && (
                                    <React.Fragment>
                                      <label htmlFor="town" className="mb-2">
                                        <span><b>{APP_TEXTS.LOADS_TOWN.Content}</b></span>
                                        <select
                                          id="town"
                                          className="form-control"
                                          value={this.state.selectedTown.Town}
                                          onChange = { e => { 
                                            let selectedTown = this.state.towns.find(town => town.Town === e.target.value);
                                            this.setState({ selectedTown });
                                          }}
                                        >
                                          {this.state.towns && this.state.towns.map(town => (
                                            <option value={town.Town} key={town.Town}>{town.Town}</option>
                                          ))}
                                        </select>
                                      </label>
                                      <label htmlFor="zone">
                                        <span><b>{APP_TEXTS.LOADS_ZONE.Content}</b></span>
                                        <span id="zone">{this.state.selectedTown.WindZone}</span>
                                      </label> 
                                      
                                    </React.Fragment>
                                  )}
                                  </div>
                                </section>
                              </div>
                              <div className="default_popup-footer">
                                <button
                                  onClick={() =>{
                                    this.setState({ zipCode: this.state.selectedTown.PostalCode, selectedTown: this.state.selectedTown });
                                    this.handleWindZoneChange(Number(this.state.selectedTown.WindZone));
                                    close();
                                  }}
                                  className="btn btn-sm default_popup-button"
                                  disabled={!this.state.selectedTown || !this.state.isValidZipCode}
                                >
                                  {APP_TEXTS.ANCHOR_SELECTION_OK.Content}
                                </button>
                                <button
                                  onClick={() =>{
                                    this.setState({ zipCode: "", selectedTown: "" });
                                    close();
                                  }}
                                  className="btn btn-sm default_popup-button"
                                >
                                  {APP_TEXTS.BUTTONS_CANCEL.Content}
                                </button>
                              </div>
                              </React.Fragment>
                            )}
                        </Popup>  
                      </Tooltip>
                      {this.state.selectedTown && (
                        <button
                          className="btn p-0 ml-2" 
                          onClick={() => {
                            this.setState({ zipCode: "", selectedTown: "", isValidZipCode: false });
                          }}>
                          <span className="icon_uncheck align-middle"/>
                        </button>
                      )}
                    </div>
                    <div className="ml-2">
                      {this.state.selectedTown && (
                        <div className="zone-desc">
                          <label htmlFor="zipCode">{APP_TEXTS.LOADS_ZIP_CODE.Content}</label> 
                          <span id="zipCode">{this.state.selectedTown.PostalCode}</span> <br/>
                          
                          <label htmlFor="town">{APP_TEXTS.LOADS_TOWN.Content}</label> 
                          <span id="town">{this.state.selectedTown.Town}</span> <br/>
                          
                          <label htmlFor="zone">{APP_TEXTS.LOADS_ZONE.Content}</label> 
                          <span id="zone">{this.state.selectedTown.WindZone}</span>
                        </div>
                      )}
                    </div>
                  </React.Fragment>
              ) : (
                <Input
                  className="w-32"
                  postfix="m.s⁻¹"
                  id="wind_speed_input"
                  value={this.props.windLoadData.vb}
                  onUpdate={this.handleWindSpeedChange}
                  type="number"
                />
              )}
            </div>
          </div>
          <div className="mb-4 d-flex align-items-center">
            <span className="mr-2">
              {APP_TEXTS.GROUND_SELECTION_TITLE.Content}
            </span>
            <UncontrolledDropdown className="design-dropdown">
              <DropdownToggle caret className="design-dropdown-toggle">
                {this.props.windLoadData.groundCategory || "Select Ground Category"}
              </DropdownToggle>
              <DropdownMenu className="design-dropdown-menu">
                {groundCategories.map((category) => (
                  <DropdownItem
                    key={category}
                    onClick={() => this.handleGroundCategoryChange(category)}
                  >
                    {category}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
          <div className="mb-4">
            <h4>{APP_TEXTS.BUILDING_DESCRIPTION_TITLE.Content}</h4>
            <div className="grid grid-cols-2 gap-4">
              <div className="d-flex justify-content-between align-items-center">
                <label htmlFor="building_width">{`${APP_TEXTS.WIDTH_LABEL.Content}:`}</label>
                <Input
                  className="w-full"
                  postfix="m"
                  id="building_width"
                  value={this.props.buildingDescription.width}
                  onUpdate={(value) =>
                    this.handleBuildingDimensionChange("width", value)
                  }
                  type="number"
                />
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <label htmlFor="building_length">
                  {APP_TEXTS.LENGTH_LABEL.Content}
                </label>
                <Input
                  className="w-full"
                  postfix="m"
                  id="building_length"
                  value={this.props.buildingDescription.length}
                  onUpdate={(value) =>
                    this.handleBuildingDimensionChange("length", value)
                  }
                  type="number"
                />
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <label htmlFor="building_height">{`${APP_TEXTS.HEIGHT_LABEL.Content} [H]: `}</label>
                <Input
                  className="w-full"
                  postfix="m"
                  id="building_height"
                  value={this.props.buildingDescription.height}
                  onUpdate={(value) =>
                    this.handleBuildingDimensionChange("height", value)
                  }
                  type="number"
                />
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <label htmlFor="barrier_height">{`${APP_TEXTS.HEIGHT_LABEL.Content} [Z] of barriers: `}</label>
                <Input
                  className="w-full"
                  postfix="m"
                  id="barrier_height"
                  value={this.props.buildingDescription.barrierHeight}
                  onUpdate={(value) =>
                    this.handleBuildingDimensionChange("barrierHeight", value)
                  }
                  type="number"
                />
              </div>
            </div>
          </div>
          <div className="custom-control custom-checkbox mt-4">
            <input
              className="custom-control-input"
              id="isEdgeCheckbox"
              type="checkbox"
              checked={this.props.buildingDescription.isEdge}
              onChange={(e) => this.handleBuildingDimensionChange("isEdge", e.target.checked)}
            />
            <label className="custom-control-label" htmlFor="isEdgeCheckbox">
              {APP_TEXTS.IS_EDGE_CHECKBOX.Content}
            </label>
          </div>
        </section>
        <section>
          <div className="mt-4">
            <img src={SafetyBarriersBuilding} alt="Building dimensions diagram" />
          </div>
        </section>
      </div>
    );
  }

};

const mapState = (state) => ({
  loadUnit: state.main.units.load,
  country: state.main.localization.country,
  deadLoad: state.selectors.loads[APP_TYPES.SAFETY_BARRIER].deadLoad.g,
  buildingDescription: state.selectors.loads[APP_TYPES.SAFETY_BARRIER].buildingDescription,
  windLoadData: {
    windZone: state.selectors.loads[APP_TYPES.SAFETY_BARRIER].windLoad.windZone,
    vb: state.selectors.loads[APP_TYPES.SAFETY_BARRIER].windLoad.vb,
    groundCategory: state.selectors.loads[APP_TYPES.SAFETY_BARRIER].windLoad.groundCategory,
  },
});
const mapDispatch = {
  setCladdingDeadLoad,
  setCladdingWindLoad,
  setCladdingBuildingDimensions,
};
export default connect(mapState, mapDispatch)(DeadLoadAndWindLoad);



// WEBPACK FOOTER //
// ./src/views/Loads/SafetyBarriers/DeadLoad/DeadLoadAndWindLoad.js